module.exports = __webpack_public_path__ + "static/media/is_operated_roof.f64af54c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/is_operated_roof.svg
// module id = 1436
// module chunks = 0